import { Link } from "react-router-dom";
import appstore from "../../assets/images/all-img/app-store.png";
import client from "../../assets/images/all-img/client.png";
import handMockup from "../../assets/images/all-img/hand-mocup.png";
import playstore from "../../assets/images/all-img/play-store.png";
import starShape from "../../assets/images/all-img/star-shape.png";
import shape1 from "../../assets/images/shape/shape1.png";
import shape2 from "../../assets/images/shape/shape2.png";
import star1 from "../../assets/images/svg/star1.svg";
import star2 from "../../assets/images/svg/star2.svg";

export default function HeroSection() {
	return (
		<div className="fugu-hero-section">
			<div className="container">
				<div className="row">
					<div className="col-xl-6 col-lg-7">
						<div className="fugu-hero-content">
							<h1 className="wow fadeInUpX" data-wow-delay="0s">
								The crypto trading app for the next-gen
							</h1>
							<p className="wow fadeInUpX" data-wow-delay="0.25s">
								Fugu is the app that gives you access to trading tools that you can actively buy & sell
								digital currencies in an optimal way.
							</p>
							<div className="fugu-app-btn-wrap wow fadeInUpX" data-wow-delay="0.40s">
								<Link to={"contact"} className="fugu-app-btn" >
										<img src={appstore} alt="title" />
								</Link>
								<Link to={"contact"} className="fugu-app-btn" >
										<img src={playstore} alt="title" />
								</Link>
							</div>
							<div className="fugu-hero-client-area wow fadeInUpX" data-wow-delay="0.50s">
								<div className="fugu-hero-client-wrap">
									<div className="fugu-hero-client-thumb">
										<img src={client} alt="title" />
									</div>
									<div className="fugu-hero-client-data">
										<h3>64,739</h3>
										<p>Happy Customers</p>
									</div>
								</div>
								<div className="fugu-hero-client-rating">
									<h3>4.8/5</h3>
									<ul>
										<li>
											<img src={star1} alt="title" />
										</li>
										<li>
											<img src={star1} alt="title" />
										</li>
										<li>
											<img src={star1} alt="title" />
										</li>
										<li>
											<img src={star1} alt="title" />
										</li>
										<li>
											<img src={star2} alt="title" />
										</li>
										<li>Rating</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-5">
						<div className="fugu-hero-thumb">
							<img src={handMockup} alt="title" />
							<div className="fugu-shape2">
								<img src={shape2} alt="title" />
							</div>
							<div className="fugu-hero-star">
								<img src={starShape} alt="title" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="fugu-shape1">
				<img src={shape1} alt="title" />
			</div>
		</div>
	);
}
